import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const pdpBundlingSelector = createSelector(testTargetOffersSelector, offers => offers.pdpBundling || Empty.Object);

export { pdpBundlingSelector };
